module.exports = __webpack_public_path__ + "imgs/letape.56572785.webp";